import React, { useState, useEffect } from "react";
import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Carlos Rodríguez",
    company: "TechCorp",
    image:
      "https://i.pinimg.com/236x/0e/17/ca/0e17caf96354a1cbde7b15145997edc6.jpg",
    text: "Excelente trabajo y profesionalismo. Entregaron el proyecto antes de lo esperado.",
    role: "CEO",
  },
  {
    name: "Ana Martínez",
    company: "Digital Solutions",
    image: "https://avatars.githubusercontent.com/u/33347782?v=4",
    text: "La mejor decisión fue trabajar con huakar. Su equipo es muy profesional.",
    role: "Project Manager",
  },
  {
    name: "Diego López",
    company: "StartupX",
    image: "https://avatars.githubusercontent.com/u/227258?v=4",
    text: "Increíble atención al detalle y soporte técnico excepcional.",
    role: "Tech Lead",
  },
];

export default function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );

    const section = document.getElementById("testimonials");
    if (section) observer.observe(section);

    return () => {
      if (section) observer.unobserve(section);
    };
  }, []);

  return (
    <section
      id="testimonials"
      className="py-24 bg-gradient-to-b from-black to-gray-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div
          className={`text-center mb-16 transform transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-4xl md:text-6xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent mb-6">
            Testimonios
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto">
            Descubre lo que nuestros clientes dicen sobre nuestra dedicación y
            resultados
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`transform transition-all duration-500 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="relative group">
                {/* Card */}
                <div className="relative z-10 h-full p-8 bg-gray-800 rounded-2xl transform transition-all duration-300 group-hover:-translate-y-2">
                  {/* Quote Icon */}
                  <div className="absolute -top-4 right-8 w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center transform -rotate-6">
                    <svg
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 01-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
                    </svg>
                  </div>

                  {/* Content */}
                  <div className="mb-8">
                    <p className="text-gray-300 italic">"{testimonial.text}"</p>
                  </div>

                  {/* User Info */}
                  <div className="flex items-center">
                    <div className="relative">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-12 h-12 rounded-full object-cover ring-2 ring-yellow-500"
                      />
                      <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-gray-800"></div>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold text-white">
                        {testimonial.name}
                      </h3>
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-400">
                          {testimonial.role}
                        </span>
                        <span className="text-xs text-yellow-500">
                          {testimonial.company}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Rating */}
                  <div className="absolute bottom-8 right-8">
                    <div className="flex space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={16}
                          className="text-yellow-400 fill-current"
                        />
                      ))}
                    </div>
                  </div>
                </div>

                {/* Background Decoration */}
                <div className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-2xl transform transition-all duration-300 group-hover:rotate-1 group-hover:scale-105 -z-10 opacity-20"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
